import {FC, useMemo} from 'react';
import {Col, Row} from 'react-bootstrap';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {FormPageHeader, FormPageFooter} from "@components/falcon/common/forms";
import {ConditionBaseInfoBlock, ConditionDonateBlock} from "../forms";
import {GoalConditionFormValues} from "../forms/conditionBaseInfoBlock";
import {GoalConditionType} from "@interfaces/consumer/refs";

interface GoalConditionFormProps {
    initialValues: GoalConditionFormValues;
    onSubmit: (values: GoalConditionFormValues) => Promise<any>;
    editForm?: boolean;
    title: string;
    cancelUrl: string;
}

const GoalConditionForm: FC<GoalConditionFormProps> = ({
    initialValues,
    onSubmit,
    editForm,
    title,
    cancelUrl
}) => {

    const validationSchema = useMemo(() => Yup.object<GoalConditionFormValues>({
        name: Yup.string()
            .max(256)
            .required(),
        isActive: Yup.boolean()
            .required(),
        type: Yup.mixed<GoalConditionType>()
            .oneOf(Object.values(GoalConditionType))
            .required(),
        donateValue: Yup.number()
            .when("type", {
                is: GoalConditionType.Donate,
                then: schema => schema
                    .min(1)
                    .max(1000000)
                    .required()
            })
    }), []);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            enableReinitialize
        >
            {({ values: { type } }) => (
                <Form>
                    <Row className="g-3">
                        <Col lg={12}>
                            <FormPageHeader title={title} />
                        </Col>
                        <Col lg={type === GoalConditionType.Donate ? 8 : 12}>
                            <ConditionBaseInfoBlock editForm={editForm} />
                        </Col>
                        { type === GoalConditionType.Donate && (
                            <Col lg={4}>
                                <ConditionDonateBlock />
                            </Col>
                        )}
                        <Col>
                            <FormPageFooter cancelUrl={cancelUrl} />
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    );
};

export default GoalConditionForm;
